import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import DisplayGraph from './component/DisplayGraph';
import HomePage from './component/HomePage';
import './App.css';

// Redirects any unmatched path to /homePage while preserving the query
// string (e.g. ?json=...&kg=... sent by an external app like Schema Link),
// which a plain <Navigate to="/homePage" /> would otherwise drop.
function RedirectToHomePage() {
  const location = useLocation();
  return <Navigate to={`/homePage${location.search}`} replace />;
}

function App() {

  return (
    <Router>
      <Routes>
        <Route path='*' element={<RedirectToHomePage />}/>

        <Route path='/homePage' element={<HomePage />}/>

        <Route path='/displayGraph' element={<DisplayGraph />}/>
      </Routes>
    </Router>
  );
}

export default App;
